<script lang="ts">
  import { onMount } from "svelte";
  import { section, challenge, initSectionAndChallenge } from "./task-submission.store";
  import MainLayout from "../../layout/MainLayout.svelte";
  import { navigate } from "../../app.logic";
  import TaskSubmissionTabs from "./TaskSubmissionTabs.svelte";
  import StarsGrade from "../../components/Business/StarsGrade.svelte";
  import Icon from "../../components/Icon.svelte";
  import { ChallengePage } from "./challenge-tab";

  export let sectionId: number;
  export let challengeId: number;
  export let currentTab: ChallengePage;
  export let submissionResults: boolean = false;

  function backToCategories() {
    navigate(`/task`);
  }

  function backToSection() {
    navigate(`/task/${sectionId}`);
  }

  function backToChallenge() {
    navigate(`/task/${sectionId}/${challengeId}/submission`);
  }

  onMount(() => initSectionAndChallenge(sectionId, challengeId));
</script>

<MainLayout>
  {#if $section && $challenge}
    <nav class="breadcrumb" aria-label="breadcrumbs">
      <!-- svelte-ignore a11y-missing-attribute -->
      <!-- svelte-ignore a11y-no-static-element-interactions -->
      <!-- svelte-ignore a11y-click-events-have-key-events -->
      <ul>
        <li><a on:click={(_) => backToCategories()}>Categories</a></li>
        <li><a on:click={(_) => backToSection()}>{$section.name || ""}</a></li>
        {#if submissionResults == false}
          <li class="is-active"><a aria-current="page">{$challenge.name || ""}</a></li>
        {:else}
          <li><a on:click={(_) => backToChallenge()}>{$challenge.name || ""}</a></li>
          <li class="is-active"><a aria-current="page">Submission Results</a></li>
        {/if}
      </ul>
    </nav>
  {/if}

  {#if $challenge}
    <div class="challenge-heading">
      <h1 class="title">{$challenge.name}</h1>
      <div class="challenge-specs noselect">
        <div class="spec-item">
          <StarsGrade value={$challenge.difficulty} />
        </div>
        <div class="spec-item">
          <Icon name="storage" handleClick={false} />
          <span class="spec-item-description">{$challenge.memoryMb} MiB</span>
        </div>
        <div class="spec-item">
          <Icon name="schedule" handleClick={false} />
          <span class="spec-item-description">{Math.floor($challenge.runtimeMs / 1000)} s</span>
        </div>
      </div>
    </div>

    <TaskSubmissionTabs {sectionId} {challengeId} tab={currentTab} />
  {/if}

  <slot />
</MainLayout>

<style>
  .challenge-heading {
    position: relative;
  }

  .challenge-specs {
    display: flex;
    flex-direction: row;
    float: right;
    margin-right: 0.75rem;
    margin-top: 0.5rem;
    right: 0;
    top: 0;
    position: absolute;

    background-color: #fefefe;
    border-radius: 1rem;
    padding: 0.25rem 1rem;
    border: 1px solid #ddd;
  }

  .spec-item {
    display: inline-flex;
    margin-right: 0.75rem;
  }

  .spec-item-description {
    margin-left: 0.25rem;
  }
</style>
